import {
   closeWebView,
   getLoggedInNumber,
   isMobileApp,
   showAppToolBar,
} from '@airtel-lego/native-app-bridge';
import { createArtistInstance } from '@airtel/air-artist';
import { Modal, StateConfigProvider, ThemeTypes } from '@airtel/air-design-system';
import { StatusCardWidget } from '@airtel/air-widgets-library';
import { getLoggedInUser, isUserLoggedIn } from '@airtel/air-utils';
import { FC, Suspense, lazy, useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
   deAllocateNumber,
   generateChangeActions,
   handlePOISameAsPOA,
   handleThankyouPage,
   handleUpdateDob,
   handleValidDisabilityInfo,
   handleValidLocalReferenceInfo,
   handleValidSimDeclaration,
   onDatePickedUtil,
   onSubRadioPressUtil,
   redirectToOrderSummaryPage,
   showLinkListItemBasedOnLob,
   storeInteractionId,
   validatePortNumber,
   onUpdateCartUserDetails,
   onGuardianNameChange,
   onRefreeNameChange,
   // handleVerificationPageOnload,
   fallbackRedirectionUtil,
   handleServiceSelection,
   handleValidLocalReferenceMobileNumber,
   handleSendSMSPress,
   handleAadhaarSameSelection,
   handleNewThankyouPage,
   handleCocpThankyouPage,
   updateEstimatedDeliveryInStepper,
   portNumberValidation,
   handleHomeNavigation,
   handleSimNumberValidation,
   handleMNPStepAction,
   handleReserveNumber,
   handleDisabilitySelection,
   handleAnalyticsAction,
   handleGtmDatalayer,
   handleStepperUI,
   maskSearchPattern,
   handleSearchBarChangeText,
   handleSearchBarUI,
   trackOrderNavigationAction,
   resizeObserver,
} from '../../common/commonUtils';
import {
   callSendAadhaarOtp,
   callSendOtp,
   callSendOtpPrepaidSkyc,
   callSendOtpCocpToRetail,
   sendOtpSimActivation,
   callSendOtpSkycNew,
   callSendRefereeAndSubmitOtp,
   callVerifyAadhaarOtp,
   callVerifyRefereeAndSubmitOtp,
   storeBouncerSendOTP,
   storeBouncerValidateOTP,
   validateOtp
} from '../../common/otpUtils';
import { 
   handlefetchEID , 
   checkEsimCompatiblity , 
   validatePortNumberRevamp , 
   checkReduxData , 
   checkVerificationReduxData,
   handleAadhaarDetail,
   handleCheckBox,
   checkWebType,
   savedLoggedInSiNumberAndPrefillInput,
   checkPlanBackButton,
   handleAddressChange,
   handleSendSMSPressRevamp,
   hideKeyBoard,
   callBouncerOtp
} from '../../common/commonUtilsRevamp'
import {
   fetchUserLocation,
   getLocationPermissionModalData,
   requestLocationPermission,
} from '../../common/routes/locationUtils';
import {
   onSuccessUpload,
   savePOIImages,
   uploadDisabilityProof,
   uploadPOAAndPOIProof,
} from '../../common/uploadUtils';
import {
   closeImageModal,
   handleFaceMatchResponse,
} from '../../common/userImageUploadUtils';
import {
   closeImageModalRevamp,
   handleFaceMatchResponseRevamp,
} from '../../common/userImageUploadUtilsRevamp';
import { closeVideoModal } from '../../common/userVideoUploadUtils';
import { closeVideoModalRevamp } from '../../common/userVideoUploadUtilsRevamp';
import {
   API_CONFIGS,
   PREPAID_LAYOUT,
   PREPAID_SIM_LAYOUT,
   SKYC_REVAMP_LAYOUT,
   SKYC_REVAMP_MIDDLE_LAYOUT,
   PUBLIC_KEY_URL,
   Variant_2,
   getCurrentJourney,
   isRevampSKYCJourney
} from '../../constants/AppConstants';
import { IS_PRODUCTION, PAGESPACE_PAGES } from '../../constants/RouteConstants';
import { addZIndexToAllSteps } from '../../utils/CommonUtils';
import ImageModal from '../image-modal/ImageModal';
import ImageModalNew from '../image-modal-new/ImageModalNew';
import { Location } from '../image-modal/ImageModalPropTypes';
import QRScannerModal from '../qr-scanner-modal/QRScannerModal';
import VideoModal from '../video-modal/VideoModal';
import { LayoutPropTypes } from './LayoutPropTypes';
import { LinkListItemWidget } from '@airtel/air-widgets-library/lib/components';
import { checkPrepaidServiceability } from '../../common/serviceabilityUtils';
import { navigateToPayment, navigateToPaymentRevamp } from '../../common/paymentUtils';
import ImageModalRevamp from '../image-modal-new/ImageModalRevamp';
import VideoModalRevamp from '../video-modal/VideoModalRevamp';

const usePageViews = () => {
   let location = useLocation();
   useEffect(() => {
      // remove old overlay class / inline scroll locks left by modals from prior journeys
      const htmlElement = document.getElementsByTagName('html')[0];
      htmlElement?.classList?.remove?.('omni-overflow');
      if (htmlElement?.style?.overflow === 'hidden') {
         htmlElement.style.overflow = '';
      }
      if (document.body?.style?.overflow === 'hidden') {
         document.body.style.overflow = '';
      }
   }, [location]);
};

const Header = lazy(() => import('./Header'));
const Footer = lazy(() => import('./Footer'));

// Must stay at module scope: each call returns a new component type, so
// creating it during render would remount the whole renderer.
const Artist = createArtistInstance();

const config: { theme: ThemeTypes } = { theme: 'gen4' };
const configOld: { theme: ThemeTypes } = { theme: 'white' };

export const Layout: FC<LayoutPropTypes> = (props) => {
   const isOmniWidgetBackdropEnabled = useRef(false);
   const {
      showHeader = true,
      showFooter = true,
      hideAllLinks,
      pageName = '',
      className = '',
      layoutName,
   } = props;
   const navigate = useNavigate();
   const route = useLocation();
   const [searchParams] = useSearchParams();
   usePageViews(); // to remove omni widget overflow hidden class

   const [isLoading, setIsLoading] = useState(true);
   const [isLoggedIn, setIsLoggedIn] = useState(false);
   const [isLoadingLocation, setIsLoadingLocation] = useState(false);
   const artistRef = useRef<any>();
   const [isImageModalOpen, setIsImageModalOpen] = useState(false);
   const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
   const [isQRScannerModalOpen, setIsQRScannerModalOpen] = useState(false);
   const [showFaceMatchError, setShowFaceMathError] = useState(false);
   const [faceMathErrorText, setFaceMathErrorText] = useState('');
   const isApp = isMobileApp();
   const isNotLoadingAndisWeb = !(isApp || isLoading);
   const [userLocation, setUserLocationObj] = useState({} as Location);
   const getReduxState = useRef<Function>();
   const isVideoUploaded = useRef<boolean>(false);
   const isImageUploaded = useRef<boolean>(false);
   const [qrErrorState, setQrErrorState] = useState('');
   const locationWatchRef = useRef<number>();
   const [showLocationModal, setShowLocationModal] = useState(false);
   const utmLayoutParam = searchParams.get('utm_layout');
   const utm_variant =
      window.location.pathname.includes('kyc/verification') && utmLayoutParam === PREPAID_SIM_LAYOUT 
   /** Revamp theme and host CSS; legacy layouts retain their white default. */
   const isSkycRevampHost =
      utmLayoutParam === SKYC_REVAMP_LAYOUT ||
      utmLayoutParam === SKYC_REVAMP_MIDDLE_LAYOUT ||
      [
         'SKYC_REVAMP_KYC_LANDING_PAGE',
         'NEW_ACQ_SKYC_VERIFY_AADHAAR',
         'NEW_ACQ_SKYC_LOCAL_REFERENCE',
         'NEW_ACQ_SKYC_SELFIE',
         'NEW_ACQ_SKYC_DISABILITY',
         'SKYC_REVAMP_LANDING_PAGE',
         'SKYC_REVAMP_CHOOSE_SIM_TYPE',
         'SKYC_REVAMP_SELECTCONNECTION_PAGE',
         'SKYC_REVAMP_PLAN_PAGE',
         'SKYC_REVAMP_REVIEW_PAGE',
      ].includes(pageName);
   const requestedTheme = searchParams.get('theme');
   const defaultConfig = isSkycRevampHost ? config : configOld;
   const providerConfig = useMemo(() => {
      switch (requestedTheme) {
         case 'light':
         case 'dark':
         case 'white':
         case 'gen4':
         case 'gen4_travel':
            return { theme: requestedTheme };
         default:
            return defaultConfig;
      }
   }, [requestedTheme, defaultConfig]);
   const isLegacyWhiteHost =
      PAGESPACE_PAGES.some(page => page.pageName === pageName) &&
      !isSkycRevampHost &&
      providerConfig.theme === 'white' &&
      (!requestedTheme || requestedTheme === 'white');
   const isLegacyPrepaidHost = isLegacyWhiteHost && layoutName === PREPAID_LAYOUT;

   // ADS modals render into body portals, outside the Artist container.
   useEffect(() => {
      document.body.classList.toggle('skyc-legacy-white', isLegacyWhiteHost);
      return () => document.body.classList.remove('skyc-legacy-white');
   }, [isLegacyWhiteHost]);
      
   // ? searchParams.get('utm_variant') || ''
   //    : '';
   // const isVariant2 = utm_variant.toLowerCase() === Variant_2;

   const isWidget = searchParams.get('blogJourney') === 'true';
   const isDynamicHeightEnabled = Boolean(searchParams.get('dynamicHeight'));

   const getLocation = async () => {
      if(!userLocation?.latitude) {
         artistRef?.current?.onUserAction({
            actions: [
               {
                  analyticsAction: 'pageload',
                  analyticsData: {
                     eventCategory: 'new_acq_postpaid_skyc_landing_page',
                     section: 'StepperSection',
                     subSection: 'StepperWidget',
                     eventAction: 'click',
                     eventLabel: 'location pop-up lead',
                     eventValue: 'location access needed',
                     customLabel: 'button',
                     prop35: '{{storeValues:orderData.orderData.cartId}}',
                     extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                     prop45: '{{storeValues:appData.subJourney}}',
                     eVar21: '{{storeValues:appData.loggedInNumber}}',
                     eVar36: '{{storeValues:appData.msisdn}}',
                     city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                     eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                     prop4: 'SKYC',
                     extraData11: '{{storeValues:layoutContext.layout}}',
                     prop9: '{{storeValues:appData.lob}}',
                  },
               },
            ],
         });
      }
      
      if (isApp) {
         setIsLoadingLocation(true);
         const { latitude, longitude }: any = await fetchUserLocation();
         setIsLoadingLocation(false);

         if (latitude && longitude) {
            let trimmedLat: string = parseFloat(latitude)?.toFixed(3)?.toString();
            let trimmedLong: string = parseFloat(longitude)?.toFixed(3)?.toString();
            setShowLocationModal(false)
            artistRef.current.onUserAction({
               actions: [
                  {
                     type: 'setDataInSessionStorage',
                     target: 'session',
                     payload: {
                        key: 'userLocation',
                        value: {
                           latitude: trimmedLat,
                           longitude: trimmedLong,
                        },
                        clearOnLogout: false,
                     },
                  },
                  {
                     payload: {
                        data: {
                           latitude: trimmedLat,
                           longitude: trimmedLong,
                        },
                        context: 'userLocation',
                     },
                     type: 'storeValuesInRedux',
                  }
               ],
            });
            setUserLocationObj({
               latitude: trimmedLat,
               longitude: trimmedLong,
            });
         } else {
            setShowLocationModal(true)
            requestLocationPermission(getLocation);
         }
      } else {
         if (navigator.geolocation) {
            if (locationWatchRef.current) {
               navigator.geolocation.clearWatch(locationWatchRef.current);
            }
            locationWatchRef.current = navigator.geolocation.watchPosition(
               (position: any) => {
                  if (!position?.coords?.latitude || !position?.coords?.longitude) return;

                  let trimmedLat: string = parseFloat(position?.coords?.latitude)
                     ?.toFixed(3)
                     ?.toString();
                  let trimmedLong: string = parseFloat(position?.coords?.longitude)
                     ?.toFixed(3)
                     ?.toString();

                  artistRef.current.onUserAction({
                     actions: [
                        {
                           type: 'setDataInSessionStorage',
                           target: 'session',
                           payload: {
                              key: 'userLocation',
                              value: {
                                 latitude: trimmedLat,
                                 longitude: trimmedLong,
                              },
                              clearOnLogout: false,
                           },
                        },
                        {
                           payload: {
                              data: {
                                 latitude: trimmedLat,
                                 longitude: trimmedLong,
                              },
                              context: 'userLocation',
                           },
                           type: 'storeValuesInRedux',
                        }
                     ],
                  });
                  setUserLocationObj({
                     latitude: trimmedLat,
                     longitude: trimmedLong,
                  });
                  setShowLocationModal(false)
                  if (locationWatchRef.current) {
                     navigator.geolocation.clearWatch(locationWatchRef.current);
                  }
               },
               (error: GeolocationPositionError) => {
                  if (error.code === error.PERMISSION_DENIED) {
                     setShowLocationModal(true)
                     artistRef.current.onUserAction({
                        actions: [
                           {
                              analyticsAction: 'impression',
                              analyticsData: {
                                 eventCategory: 'new_acq_postpaid_skyc_landing_page',
                                 section: 'StepperSection',
                                 subSection: 'StepperWidget',
                                 eventAction: 'impression',
                                 eventLabel: 'location permission',
                                 eventValue: 'location permission denied',
                                 customValue: 'Location permission denied. Go to Phone settings and enable location access.',
                                 customLabel: 'button',
                                 prop35: '{{storeValues:orderData.orderData.cartId}}',
                                 extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                                 prop45: '{{storeValues:appData.subJourney}}',
                                 eVar21: '{{storeValues:appData.loggedInNumber}}',
                                 eVar36: '{{storeValues:appData.msisdn}}',
                                 city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                                 eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                                 prop4: 'SKYC',
                                 extraData11: '{{storeValues:layoutContext.layout}}',
                                 prop9: '{{storeValues:appData.lob}}',
                                 eVar10: 'error',
                              },
                           },
                        ],
                     });
                  }
               }
            );
         } else {
            setShowLocationModal(true)
         }
      }      
   };

   const additionalData = useMemo(
      () => ({
         queryParams: {
            ...Object.fromEntries(searchParams.entries()),
            // Artist's nested provider otherwise inherits another journey's session theme.
            theme: searchParams.get('theme') || (isSkycRevampHost ? 'gen4' : 'white'),
         },
      }),
      [searchParams, isSkycRevampHost]
   );

   useEffect(() => {
      const path = route.pathname;

      if(isApp && isRevampSKYCJourney())
           showAppToolBar(false, true);
  
      if (path.includes('details')) {
        document.title = 'Prepaid SIM';
      } else if (path.includes('verification')) {
        document.title = 'KYC';
      } else if (path.includes('activation')) {
        document.title = 'SIM Activation';
      } else {
        document.title = 'Airtel Connection';
      }
    }, [route.pathname]);

   useEffect(() => {
      const checkOmniEventBackdrop = (e: MessageEvent<any>) => {
         const omniWidgetEventName = e?.data?.eventName;
         if (omniWidgetEventName === 'WtoC_EnableBackdrop') {
            isOmniWidgetBackdropEnabled.current = true;
         }
         if (omniWidgetEventName === 'WtoC_DisabledBackdrop') {
            isOmniWidgetBackdropEnabled.current = false;
         }
      };

      // checkWebType()

      // sessionStorage.removeItem('interactionId');
      // generateInteractionId();
      window.addEventListener('message', checkOmniEventBackdrop);
      return () => {
         window.removeEventListener('message', checkOmniEventBackdrop);
      };
   }, []);

   useEffect(() => {
      fetchPublicKey();

      if(
         window.location.pathname.includes('kyc/details') ||
         window.location.pathname.includes('kyc/reverification')
      ) {
         getLocation();
      }

      // store get state function
      if (artistRef?.current.onUserAction) {
         artistRef?.current.onUserAction({
            actions: [
               {
                  payload: {
                     args: [],
                     utilName: 'reduxStoreAction',
                  },
                  type: 'callUtilFunction',
               },
            ],
         });
      }
   }, []);

   const fetchPublicKey = async () => {
      fetch(PUBLIC_KEY_URL)
         .then((response) => {
            return response.text();
         })
         .then((data) => {
            //store the key in local storage
            localStorage.setItem('key', data);
         })
         .catch((error) => {
            // handle the error
            //call sentry
         });
   };

   const callbackHandler = (_isLoading: any) => {
      setIsLoading(_isLoading);
   };

   useEffect(() => {
      if (isApp || isUserLoggedIn()) {
         setIsLoggedIn(true);
         if (isApp) {
            getLoggedInNumber().then((number) => {
               artistRef.current?.onUserAction({
                  type: 'storeValuesInRedux',
                  payload: {
                     context: 'appData',
                     data: {
                        loggedInNumber: number,
                     },
                  },
               });
            });
         } else {
            const isWebLoggedInUser = isUserLoggedIn();
            if (isWebLoggedInUser) {
               artistRef.current?.onUserAction({
                  type: 'storeValuesInRedux',
                  payload: {
                     context: 'appData',
                     data: {
                        loggedInNumber: getLoggedInUser(),
                     },
                  },
               });
            }
         }
      }

      // //@ts-ignore
      // window['setIsImageModalOpen'] = setIsImageModalOpen;
      // //@ts-ignore
      // window['setIsVideoModalOpen'] = setIsVideoModalOpen;
      // //@ts-ignore
      // window['toggleQRCodeScanner'] = setIsQRScannerModalOpen;
   }, []);

   const removeDummyContentLoader = () => {
      try {
         const initLoader: any = document.querySelector('#init-loader');
         document.body.removeChild(initLoader);
      } catch (error) {
         //
      }
   };

   useEffect(() => {
      if (!isLoading) {
         removeDummyContentLoader();
         addZIndexToAllSteps();
      }
   }, [isLoading]);


   // Web site Header sits above renderer; keep 100vh only off-header (app/widget) to avoid phantom scroll.
   const showSiteHeader = !isWidget && isNotLoadingAndisWeb && showHeader;

   const artist = useMemo(() => {
      return (
         <div
            className={`renderer-container ${className}${
               isSkycRevampHost ? ' skyc-revamp' : ''
            }${
               isSkycRevampHost && showSiteHeader ? ' skyc-revamp-web-header' : ''
            }${
               isLegacyPrepaidHost ? ' skyc-legacy-prepaid' : ''
            } ${isLoading ? 'renderer-container-loading' : ''}`}
         >
            <Artist
               ref={artistRef}
               apiConfig={API_CONFIGS}
               analyticsEnv={IS_PRODUCTION ? 'PROD' : 'KONGQA'}
               pagesToLoad={PAGESPACE_PAGES}
               currPage={pageName}
               getPageLoadingStatus={callbackHandler}
               additionalData={additionalData}
               globalAnalyticsAttributes={{
                  journey: getCurrentJourney(),
               }}
               utilFunctions={{
                  navigate,
                  storeUniqueId: ({ args, onUserAction, getState }: any) => {
                     storeInteractionId(onUserAction,getState);
                  },
                  closeWebView: () => {
                     closeWebView?.();
                  },
                  callSendOtp,
                  callSendOtpSkycNew,
                  maskSearchPattern,
                  callSendOtpPrepaidSkyc,
                  callSendOtpCocpToRetail,
                  sendOtpSimActivation,
                  validateOtp,
                  callSendAadhaarOtp,
                  callVerifyAadhaarOtp,
                  generateChangeActions,
                  handleValidSimDeclaration,
                  handleValidDisabilityInfo,
                  handleValidLocalReferenceInfo,
                  callSendRefereeAndSubmitOtp,
                  callVerifyRefereeAndSubmitOtp,
                  onSubRadioPressUtil,
                  addZIndexToAllSteps,
                  validatePortNumber,
                  redirectToOrderSummaryPage,
                  navigateToPaymentRevamp,
                  handleFaceMatchResponse: (args: any) => {
                     const faceMatchFailureCallback = (faceAuthMessage: string) => {
                        setShowFaceMathError(true);
                        setFaceMathErrorText(faceAuthMessage);
                     };

                     handleFaceMatchResponse(args, faceMatchFailureCallback);
                  },
                  handleFaceMatchResponseRevamp: (args: any) => {
                     const faceMatchFailureCallback = (faceAuthMessage: string) => {
                        setShowFaceMathError(true);
                        setFaceMathErrorText(faceAuthMessage);
                     };

                     handleFaceMatchResponseRevamp(args, faceMatchFailureCallback);
                  },
                  handleThankyouPage,
                  uploadDisabilityProof,
                  uploadPOAAndPOIProof,
                  onSuccessUpload,
                  savePOIImages,
                  handlePOISameAsPOA,
                  openImageModal: ({ args, onUserAction }: any) => {
                     const type = args?.[0]?.type === 'changeCta';
                     if (isImageUploaded.current || !type) {
                        setIsImageModalOpen(true);
                     } else {
                        return onUserAction({
                           actions: [
                              {
                                 payload: {
                                    args: [
                                       {
                                          stepName: 'step4Widget',
                                       },
                                    ],
                                    utilName: 'generateChangeActions',
                                 },
                                 type: 'callUtilFunction',
                              },
                           ],
                        });
                     }
                  },
                  closeImageModal: (args: any) => {
                     const callback = () => {
                        isImageUploaded.current = true;
                        setIsImageModalOpen(false);
                     };
                     closeImageModal(args, callback);
                  },
                  closeImageModalRevamp: (args: any) => {
                     const callback = () => {
                        isImageUploaded.current = true;
                        setIsImageModalOpen(false);
                     };
                     closeImageModalRevamp(args, callback);
                  },
                  openVideoModal: ({ args, onUserAction }: any) => {
                     const type = args?.[0]?.type === 'changeCta';
                     if (isVideoUploaded.current || !type) {
                        setIsVideoModalOpen(true);
                     } else {
                        return onUserAction({
                           actions: [
                              {
                                 payload: {
                                    args: [
                                       {
                                          stepName: 'step5Widget',
                                       },
                                    ],
                                    utilName: 'generateChangeActions',
                                 },
                                 type: 'callUtilFunction',
                              },
                           ],
                        });
                     }
                  },
                  closeVideoModal: (args: any) => {
                     const callback = () => {
                        isVideoUploaded.current = true;
                        setIsVideoModalOpen(false);
                     };
                     closeVideoModal(args, callback);
                  },
                  closeVideoModalRevamp: (args: any) => {
                     const callback = () => {
                        isVideoUploaded.current = true;
                        setIsVideoModalOpen(false);
                     };
                     closeVideoModalRevamp(args, callback);
                  },
                  reduxStoreAction: ({ getState }: any) => {
                     getReduxState.current = getState;
                  },
                  openQRScannerModal: ({ args }: any) => {
                     setIsQRScannerModalOpen(true);
                  },
                  closeQRScannerModal: (args: any) => {
                     setIsQRScannerModalOpen(false);
                  },
                  deAllocateNumber,
                  storeBouncerSendOTP,
                  storeBouncerValidateOTP,
                  handleUpdateDob,
                  showLinkListItemBasedOnLob,
                  logData: (args: any) =>
                     alert(
                        JSON.stringify(
                           { args: args?.args, data: args?.additionalData },
                           null,
                           2
                        )
                     ),
                  onDatePickedUtil,
                  onUpdateCartUserDetails,
                  onGuardianNameChange,
                  onRefreeNameChange,
                  // handleVerificationPageOnload,
                  fallbackRedirectionUtil,
                  getLocation,
                  handleServiceSelection,
                  checkPrepaidServiceability,
                  handleAadhaarSameSelection,
                  handleNewThankyouPage,
                  handleCocpThankyouPage,
                  updateEstimatedDeliveryInStepper,
                  handleValidLocalReferenceMobileNumber,
                  navigateToPayment,
                  handleSendSMSPress,
                  portNumberValidation,
                  handleHomeNavigation,
                  handleSimNumberValidation,
                  handleMNPStepAction,
                  handleReserveNumber,
                  handleDisabilitySelection,
                  handleAnalyticsAction,
                  handleGtmDataLayerEvent: ({ args, getState }: any) => {
                     handleGtmDatalayer(args, isLoggedIn, getState)
                  },
                  handleStepperUI,
                  handleSearchBarChangeText,
                  handleSearchBarUI,
                  trackOrderNavigationAction,
                  handlefetchEID : ({onUserAction }: any) => {
                     handlefetchEID(onUserAction);
                  },
                  checkEsimCompatiblity , 
                  validatePortNumberRevamp , 
                  checkReduxData , 
                  checkVerificationReduxData,
                  handleAadhaarDetail,
                  savedLoggedInSiNumberAndPrefillInput : ({onUserAction }: any) => {
                     savedLoggedInSiNumberAndPrefillInput(onUserAction);
                  },
                  handleCheckBox,
                  checkWebType,
                  checkPlanBackButton,
                  handleAddressChange,
                  handleSendSMSPressRevamp,
                  hideKeyBoard,
                  callBouncerOtp
               }}
            />
         </div>
      );
   }, [pageName, isLoading, JSON.stringify(additionalData), isSkycRevampHost, isLegacyPrepaidHost, showSiteHeader]);

   useEffect(() => {
      if (isImageModalOpen || isVideoModalOpen) {
         document.body.style.overflow = 'hidden';
      } else {
         document.body.style.overflow = '';
      }

      return () => {
         document.body.style.overflow = '';
      };
   }, [isImageModalOpen, isVideoModalOpen]);

   useEffect(() => {
      const widgetBody = document.body;

      if (isDynamicHeightEnabled) {
         document.body.style.setProperty('overflow', 'hidden', 'important');
         document.documentElement.style.setProperty('overflow', 'hidden', 'important');
         return () => {
            document.body.style.removeProperty('overflow');
            document.documentElement.style.removeProperty('overflow');
         };
      }
      
      if (isWidget) {
         widgetBody.style.height = 'auto';
         const renderContainer = document.querySelectorAll('.renderer-container');
         const firstRendeContainer = renderContainer?.[0] as HTMLElement;

         if (isWidget) {
            const firstChildNodes = renderContainer?.[0]?.childNodes?.[0] as HTMLElement;
            if (firstChildNodes?.style) firstChildNodes.style.minHeight = 'auto';
         }

         if (firstRendeContainer?.style) firstRendeContainer.style.minHeight = 'auto';
         isDynamicHeightEnabled && resizeObserver.observe(widgetBody);
      }

      return () => {
         resizeObserver.unobserve(widgetBody);
      };
   }, [isDynamicHeightEnabled, isWidget]);

   return (
      <Suspense fallback={null}>
         {showSiteHeader && <Header isLoggedIn={isLoggedIn} />}
         <StateConfigProvider config={providerConfig}>
            {artist}
            {/* Mount only when needed — stale sessionStorage layout previously
                opened this Modal and locked html/body overflow. */}
            {layoutName !== PREPAID_LAYOUT &&
               showLocationModal &&
               (window.location.pathname.includes('kyc/details') ||
                  window.location.pathname.includes('kyc/reverification')) && (
               <Modal
                  initialVisible={true}
                  visible={
                     showLocationModal &&
                     (window.location.pathname.includes('kyc/details') ||
                        window.location.pathname.includes('kyc/reverification'))
                  }
                  swipeEnabled={false}
                  closeOnPressMask={false}
               >
                  <StatusCardWidget
                     title={{
                        text: isLoadingLocation
                           ? 'Fetching your location'
                           : 'Enable Location Access',
                     }}
                     subtitle={{
                        text: isLoadingLocation
                           ? ''
                           : 'We need access to your device location for the digital KYC process.',
                     }}
                     statusCardImage={{
                        imageUrl:
                           'https://assets.airtel.in/static-assets/acq-skyc/lcoation-permission.png',
                     }}
                     type={isLoadingLocation ? 'loader' : 'image'}
                  />
                  <div>
                     <LinkListItemWidget
                        style={{ pointerEvents: 'none', cursor: 'default' }}
                        heading={'Follow these steps to enable location:'}
                     />
                     {getLocationPermissionModalData().map(
                        (item, index) =>
                           item && (
                              <LinkListItemWidget
                                 style={{
                                    pointerEvents: 'none',
                                    cursor: 'default',
                                 }}
                                 key={index}
                                 subHeading={item.subTitle}
                                 imageUrl={item.iconUrl}
                                 isLink={false}
                                 isDisabled={true}
                              />
                           )
                     )}
                  </div>
               </Modal>
            )}
            {isRevampSKYCJourney() ? (
               <ImageModalRevamp
                  visible={isImageModalOpen}
                  artistRef={artistRef}
                  userLocation={userLocation}
                  getReduxState={getReduxState.current}
                  isUploaded={isImageUploaded}
                  showFaceMatchError={showFaceMatchError}
                  faceMathErrorText={faceMathErrorText}
                  setShowFaceMathError={setShowFaceMathError}
                  setIsImageModalOpen={setIsImageModalOpen}
               />
            ) : utm_variant ? (
               <ImageModalNew
                  visible={isImageModalOpen}
                  artistRef={artistRef}
                  userLocation={userLocation}
                  getReduxState={getReduxState.current}
                  isUploaded={isImageUploaded}
                  showFaceMatchError={showFaceMatchError}
                  faceMathErrorText={faceMathErrorText}
                  setShowFaceMathError={setShowFaceMathError}
                  setIsImageModalOpen={setIsImageModalOpen}
               />
            ) : (
               <ImageModal
                  visible={isImageModalOpen}
                  artistRef={artistRef}
                  userLocation={userLocation}
                  getReduxState={getReduxState.current}
                  isUploaded={isImageUploaded}
                  showFaceMatchError={showFaceMatchError}
                  faceMathErrorText={faceMathErrorText}
                  setShowFaceMathError={setShowFaceMathError}
                  setIsImageModalOpen={setIsImageModalOpen}
               />
            )}

            {isRevampSKYCJourney() ? (
               <VideoModalRevamp
               visible={isVideoModalOpen}
               artistRef={artistRef}
               userLocation={userLocation}
               getReduxState={getReduxState.current}
               isUploaded={isVideoUploaded}
               setIsVideoModalOpen={setIsVideoModalOpen}
            />
            ) : (
            <VideoModal
               visible={isVideoModalOpen}
               artistRef={artistRef}
               userLocation={userLocation}
               getReduxState={getReduxState.current}
               isUploaded={isVideoUploaded}
               setIsVideoModalOpen={setIsVideoModalOpen}
            />
            )}
           
            <QRScannerModal
               visible={isQRScannerModalOpen}
               artistRef={artistRef}
               errorState={qrErrorState}
               setErrorState={setQrErrorState}
               setIsQRScannerModalOpen={setIsQRScannerModalOpen}
            />
         </StateConfigProvider>

         {isNotLoadingAndisWeb && showFooter && <Footer hideAllLinks={hideAllLinks} />}
      </Suspense>
   );
};